const SWAP_KEY = 'otopiece_swaps';
const PROMO_KEY = 'otopiece_promo';
const DEFAULT_SHIP = { freeFrom: 120, price: 5.99 };

const readJson = (storage, key, fallback) => { try { return JSON.parse(storage.getItem(key)) ?? fallback; } catch { return fallback; } };

export const swapStore = {
  all: () => readJson(localStorage, SWAP_KEY, {}),
  record: (altId, data) => localStorage.setItem(SWAP_KEY, JSON.stringify({ ...swapStore.all(), [altId]: data })),
  forget: (altId) => { const s = swapStore.all(); delete s[altId]; localStorage.setItem(SWAP_KEY, JSON.stringify(s)); },
  clear: () => localStorage.removeItem(SWAP_KEY),
};

export const PENDING_PROMO_KEY = 'otopieces_pending_promo';
export const promoSession = {
  get: () => readJson(sessionStorage, PROMO_KEY, null),
  set: (promo) => (promo ? sessionStorage.setItem(PROMO_KEY, JSON.stringify(promo)) : sessionStorage.removeItem(PROMO_KEY)),
  clear: () => sessionStorage.removeItem(PROMO_KEY),
};

export const computeSavings = (items, promo, ship = DEFAULT_SHIP) => {
  const fee = ship?.price ?? DEFAULT_SHIP.price;
  const freeFrom = ship?.freeFrom;
  const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);
  const tier = items.reduce((s, i) => s + (i.discount_pct && i.base_price ? (i.base_price - i.price) * i.quantity : 0), 0);
  const swaps = swapStore.all();
  const swapped = items.reduce((s, i) => (!i.pack_id && swaps[i.product_id] ? s + (swaps[i.product_id].saved_per_unit || 0) * i.quantity : s), 0);
  const promoDiscount = promo ? Math.min(promo.discount || 0, subtotal) : 0;
  const shippingWouldCost = freeFrom != null && subtotal >= freeFrom ? 0 : fee;
  const freeShipping = promo?.free_shipping && shippingWouldCost > 0 ? fee : 0;
  const lines = [
    tier > 0 && { key: 'tier', label: 'Remises quantité / prix pro', amount: tier },
    swapped > 0 && { key: 'swaps', label: 'Alternatives moins chères choisies', amount: swapped },
    promoDiscount > 0 && { key: 'promo', label: `Code promo ${promo.code}`, amount: promoDiscount },
    freeShipping > 0 && { key: 'shipping', label: 'Livraison offerte par le code', amount: freeShipping },
  ].filter(Boolean);
  return { subtotal, promoDiscount, shipping: promo?.free_shipping ? 0 : shippingWouldCost, lines, total: lines.reduce((s, l) => s + l.amount, 0) };
};
